import ComingSoonIcon from "../../images/svgs/ComingSoonIcon";

const ComingSoon = ({ content }) => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-white rounded-xl">
      <div className="flex flex-col items-center text-center w-full max-w-lg md:max-w-2xl">
        <ComingSoonIcon />
        <p className="bg-custom-gradient bg-clip-text text-transparent font-bold text-2xl sm:text-3xl mb-6">
          Coming Soon!
        </p>

        <div className="font-medium text-sm sm:text-base text-gray-500 mt-2.5">
          {content}
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
